var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobTitle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 23H4.5C3.67275 23 3 22.3272 3 21.5V3.5C3 2.67275 3.67275 2 4.5 2H16.5C17.3273 2 18 2.67275 18 3.5V11H16.5V3.5H4.5V21.5H9V23Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 16.6926L18.3105 15.5031L19.5 14.3136L20.6895 15.5031L19.5 16.6926ZM14.6895 21.5031H13.5V20.3136L17.25 16.5636L18.4395 17.7531L14.6895 21.5031ZM22.2802 14.9729L20.0302 12.7229C19.737 12.4296 19.263 12.4296 18.9697 12.7229L12 19.6926V23.0031H15.3105L22.2802 16.0334C22.5735 15.7401 22.5735 15.2661 22.2802 14.9729Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 11.75H8.25C7.00725 11.75 6 12.7573 6 14V14.75H7.5V14C7.5 13.586 7.836 13.25 8.25 13.25H12.75C13.164 13.25 13.5 13.586 13.5 14V14.75H15V14C15 12.7573 13.9928 11.75 12.75 11.75Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.5C11.3288 6.5 12 7.17125 12 8C12 8.82875 11.3288 9.5 10.5 9.5C9.67125 9.5 9 8.82875 9 8C9 7.17125 9.67125 6.5 10.5 6.5ZM10.5 11C12.1568 11 13.5 9.65675 13.5 8C13.5 6.34325 12.1568 5 10.5 5C8.84325 5 7.5 6.34325 7.5 8C7.5 9.65675 8.84325 11 10.5 11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobTitle);
export default __webpack_public_path__ + "static/media/job-title.086e868ff14873b619766dc4ee9810ca.svg";
export { ForwardRef as ReactComponent };